<p class="m-b-16">
  <strong>{{ session.title }}</strong>
</p>
<p class="m-b-8">
  <fa-icon class="c-primary" [icon]="faUserGroup"></fa-icon>
  <span i18n>Capacity: </span>
  <span>{{ session.capacity }}</span>
</p>
<p class="m-b-8">
  <fa-icon class="c-success" [icon]="faCalendar"></fa-icon>
  <span i18n>Star Date: </span>
  <span>{{ session.start | date }}</span>
</p>
<p class="m-b-8">
  <fa-icon class="c-secondary" [icon]="faCalendarMinus"></fa-icon>
  <span i18n>End Date: </span>
  <span>{{ session.end | date }}</span>
</p>
<p class="m-b-8">
  <fa-icon class="c-error" [icon]="faCalendarTimes"></fa-icon>
  <span i18n>Booking dedline: </span> <span>{{ session.deadline | date }}</span>
</p>
